import icons from "../../config/icons";

export const PG_LABELS = {
  ENTER_EMAIL_PLACEHOLDER: "ENTER_EMAIL_PLACEHOLDER",
  INCORRECT_EMAIL_ERR_MSG: "INCORRECT_EMAIL_ERR_MSG",
  EMAIL_MAX_LENGTH_ERR_MSG: "EMAIL_MAX_LENGTH_ERR_MSG",
  PAYMENT_GATEWAY: "PAYMENT_GATEWAY",
  PAYMENT_GATEWAY_CAPS: "PAYMENT GATEWAY",
  POWERED_BY: "POWERED_BY",
  SOME_ERR: "SOME_ERR",
  GUEST: "g_",
  PAYSTACK: "paystack",
  PAYSTACK_CAPS: "PAYSTACK",
  UBA: "UBA",
  FLUTTERWAVE: "flutterwave",
  PG_NAVIGATION: "PG_NAVIGATION"
}

export const PG_PAY_OPTIONS = {
  PAYSTACK: PG_LABELS.PAYSTACK_CAPS,
  UBA: PG_LABELS.UBA
}

export const PG_PAY_OPTIONS_BETA_CODES = {
  PAYSTACK: PG_LABELS.PAYSTACK,
  UBA: PG_LABELS.FLUTTERWAVE
}

export const PG_ICONS = {
  PAYSTACK: { name: PG_LABELS.PAYSTACK, alt: PG_LABELS.PAYSTACK, height: 15, width: 86 },
  UBA: { name: PG_LABELS.FLUTTERWAVE, alt: PG_LABELS.FLUTTERWAVE, height: 24, width: 99 },
}

export const PG_COMMON_ICONS = [
  { icon: icons.visa, alt: "visa", className: "w-36 h-18" },
  { icon: icons.masterCard, alt: "masterCard", className: "w-35 h-18" },
  { icon: icons.americanExpress, alt: "americanExpress", className: "w-35 h-18 ml-2" },
  { icon: icons.discover, alt: "discover", className: "w-36 h-18 ml-2" }
];

export const PG_EVENTS = {
  GUEST: "g_",
  PAYSTACK: "paystack",
  UBA: "flutterwave",
  PG_OPTIONS: "pg-options",
  BUY_AIRTIME_:"buyairtime_",
  BUY_BUNDLE_:"buybndl_",
  PG_PAY_OPTONS_NOT_AVIALABLE: "pgpay_optsvalid_not_available",
  PAYMENT_MODE_SELECTED_ANY: "paymentmodeselected_any",
  EMAIL_ENTERED: "email_entered",
  PAYMENT_MODE_SELECTED: "paymentmodesel_",
  PAYMENT_FAILED: "paymentfailed",
  PAYMENT_SUCCESSFUL: "payment_successful",
  PAYMENT_INPROGRESS: "payment_inprogress",

  PAYSTACK_TRANSACTION_SUCCESS: "paystack_txn_successful",
  PAYSTACK_TRANSACTION_FAIL: "paystack_txn_failed",
}

export const TXN_ID = "txnId";